/** Budget Yes is last full calendar month only. Older packages go stale. */

export function previousCalendarMonth(
  today: Date = new Date(),
): { start: string; end: string } {
  const year = today.getUTCFullYear();
  const month = today.getUTCMonth();
  const start = new Date(Date.UTC(year, month - 1, 1));
  const end = new Date(Date.UTC(year, month, 0));
  return { start: isoDate(start), end: isoDate(end) };
}

export function isPreviousCalendarMonth(
  periodStart: string | null | undefined,
  periodEnd: string | null | undefined,
  today: Date = new Date(),
): boolean {
  if (!periodStart || !periodEnd) return false;
  const expected = previousCalendarMonth(today);
  return periodStart === expected.start && periodEnd === expected.end;
}

function isoDate(value: Date): string {
  return value.toISOString().slice(0, 10);
}
